import { baseApi, resourceListTag, resourceScopeTag, resourceTag } from '@krp/client-runtime'

import { AQSI_TAG_TYPES, AQSI_TAGS } from '../../../shared/api/tags'
import { AQSI_URLS } from '../../../shared/api/urls'
import type { AqsiGoodCard, AqsiGoodEditRequest, AqsiGoodEditResult } from '../model/types'
import { decodeGoodCard, decodeGoodEdit } from './contracts'

export interface GoodCardArgs {
  resourceId: string
  goodId: string
}

export interface GoodEditArgs extends GoodCardArgs {
  request: AqsiGoodEditRequest
}

/**
 * Окно товара источника: карточка кабинета живьём (только GET к кабинету) и правка карточки прямо в кабинете. Правка — один PUT без
 * повторов: служба пишет карточку (`v2/ListGoods`), читает её и только после подтверждения кладёт в снимок и индекс поиска. Не
 * подтвердила — 503 `edit-not-confirmed`, и повторять запись вслепую не нужно: сначала «Обновить из кабинета».
 */
export const goodCardApi = baseApi.enhanceEndpoints({ addTagTypes: AQSI_TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    aqsiGoodCard: build.query<AqsiGoodCard, GoodCardArgs>({
      query: ({ resourceId, goodId }) => ({ url: AQSI_URLS.goodCard(resourceId, goodId), decode: decodeGoodCard }),
      providesTags: (_result, _error, { resourceId, goodId }) => [
        resourceTag(AQSI_TAGS.goods, resourceId, `card-${goodId}`),
        resourceScopeTag(resourceId),
      ],
    }),
    aqsiGoodEdit: build.mutation<AqsiGoodEditResult, GoodEditArgs>({
      query: ({ resourceId, goodId, request }) => ({
        url: AQSI_URLS.goodEdit(resourceId, goodId),
        method: 'PUT',
        body: request,
        decode: decodeGoodEdit,
        timeoutMs: 60_000,
      }),
      invalidatesTags: (_result, _error, { resourceId, goodId }) => [
        resourceListTag(AQSI_TAGS.goods, resourceId),
        resourceTag(AQSI_TAGS.goods, resourceId, `card-${goodId}`),
        resourceTag(AQSI_TAGS.goods, resourceId, `prices-${goodId}`),
        resourceListTag(AQSI_TAGS.probe, resourceId),
        resourceListTag(AQSI_TAGS.probeStatus, resourceId),
      ],
    }),
  }),
})

export const { aqsiGoodCard, aqsiGoodEdit } = goodCardApi.endpoints
